import React, { useState } from 'react';
import './Activities.css';
import ImageModal from './ImageModal'; // Import the ImageModal component

const Activities = () => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedLongDescription, setSelectedLongDescription] = useState(""); // State to hold long description
  const [selectedPdfLinks, setSelectedPdfLinks] = useState([]); // State for PDF links

  const activitiesData = [
    {
      title: "Lab Meetings",
      description: "Our lab holds weekly meetings to discuss ongoing projects, AI breakthroughs, and future research goals as core parts of our research culture.",
      image: "https://th.bing.com/th/id/OIP.usWD4Ds7gU6ksZOZDNyF_AHaEK?w=333&h=187&c=8&rs=1&qlt=90&o=6&dpr=1.5rm=2&w=1600&h=900&dpr=1.5&pid=ImgDetMain",
      images: [
        "https://i.ibb.co/0QfNcM8/975b388aad20.png",
        "https://i.ibb.co/s9dSNz2/6a2a079b06c0.png",
        "https://i.ibb.co/HnrYD6F/b2727e0d383b.png"
      ]
    },
    {
      title: "Research Articles",
      description: "Our team publishes impactful research papers in top AI journals and conferences, making valuable contributions to the global AI community.",
      image: "https://th.bing.com/th/id/OIP.tZok00lrduTXjyeWx3dKkwHaEK?pid=ImgDet&w=226&h=127&c=7&dpr=1.5",
    },
    {
      title: "Culture Exchange Programs",
      description: "We engage in international collaborations and cultural exchange programs to broaden our perspectives and adopt global AI practices.",
      image: "https://th.bing.com/th?id=OIP.TcatY0cLmneQkyO1mfVOsgHaD4&w=345&h=180&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
      images: [
        "https://i.postimg.cc/xCqZmm7R/Whats-App-Image-2024-11-24-at-20-17-39-a1357dc5.jpg"
      ]
    },
    {
      title: "Conference",
      description: "We participate in international conferences to showcase our research, exchange knowledge, and stay at the forefront of global AI advancements.",
      image: "https://th.bing.com/th?id=OIP.2_rZEJtbJITYMaF8-9gCdgHaEK&w=333&h=187&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
      images: [
        "https://i.postimg.cc/fbN2YR6w/Screenshot-20241111-142416.png",
        "https://i.postimg.cc/SNtjXXYM/Screenshot-20241111-142434.png",
        "https://i.postimg.cc/1ztfZpgD/gorden-pic.jpg",
        "https://i.postimg.cc/DzQ7YMBr/bran-pic.jpg"
      ],
      pdfLinks: [
        { text: "IET_ICETA_Certificate.pdf", url: "IET_ICETA_Certificate.pdf" },
        { text: "IET_Conference.pdf", url: "IET_Conference.pdf" },
        { text: "IET ICETA", url: "IET_ICETA.docx" }
      ]
    }
  ];

  const handleLearnMore = (activity) => {
    setImages(activity.images || []); // Set the images for the selected activity
    setShowImageModal(true); // Show the image modal
    setSelectedLongDescription(activity.longDescription || ""); // Set long description if available
    setSelectedPdfLinks(activity.pdfLinks || []); // Set PDF links if available
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false); // Close the image modal
    setImages([]); // Clear the images
    setSelectedLongDescription(""); // Clear the long description
    setSelectedPdfLinks([]); // Clear the PDF links
  };

  return (
    <section className="activities-section">
      <div id="activities" className="container">
        <h2>Lab Activities</h2>
        <div className="activities-grid">
          {activitiesData.map((activity, index) => (
            <div key={index} className="activity-item">
              <img src={activity.image} alt={activity.title} className="activity-image" />
              <h3>{activity.title}</h3>
              <p>{activity.description}</p>
              <button onClick={() => handleLearnMore(activity)} className="learn-more-button">
                Learn More
              </button>
            </div>
          ))}
        </div>
        <ImageModal
          show={showImageModal}
          onClose={handleCloseImageModal}
          images={images}
          description={selectedLongDescription}
          pdfLinks={selectedPdfLinks}
        />
      </div>
    </section>
  );
};

export default Activities;
